module.exports = __webpack_public_path__ + "static/media/postcard12thumb.30817cf0.jpg";